import { isAfter, isToday, parseISO } from 'date-fns'
import { ClinicAvailabilities } from 'src/services/api/availabilities'
import { AllClinicsAvailabilitiesGroupedByPeriod } from '@context/AppointmentCalendarContext/types'

function chunkArray<T>(arr: T[], chunkSize: number): T[][] {
  const chunkedArray: T[][] = []
  for (let i = 0; i < arr.length; i += chunkSize) {
    chunkedArray.push(arr.slice(i, i + chunkSize))
  }
  return chunkedArray
}

export enum PeriodSize {
  Week = 5,
}

export const getAvailabilitiesGroupedBySize = (
  clinicsAvailabilities: ClinicAvailabilities[] | undefined,
  size: PeriodSize
): AllClinicsAvailabilitiesGroupedByPeriod | undefined => {
  if (!clinicsAvailabilities) return
  const result = clinicsAvailabilities.flatMap((clinicsAvailability) => {
    return Object.entries(clinicsAvailability).map(([clinicId, clinicAvailabilities]) => {
      const days = clinicAvailabilities.weeks.flatMap((el) => el)
      const firstDayWithAvailabilitiesIndex = days.findIndex((d) => d.availabilities.length > 0)
      const groupedPeriods = chunkArray(
        days
          .filter((el, i) => (size !== PeriodSize.Week ? i >= firstDayWithAvailabilitiesIndex : el))
          .filter((el) =>
            size !== PeriodSize.Week ? isToday(parseISO(el.date)) || isAfter(parseISO(el.date), new Date()) : el
          ),
        size
      )

      return { [clinicId]: groupedPeriods }
    })
  })

  const finalResult: AllClinicsAvailabilitiesGroupedByPeriod = {}

  result.forEach((item) => {
    for (const key in item) {
      if (!finalResult[key]) {
        finalResult[key] = []
      }
      finalResult[key].push(...item[key])
    }
  })

  return finalResult
}
